import React from 'react';
import { useLang } from '../context/LanguageContext';

export function LanguageSelector({ variant = 'header' }) {
  const { lang, setLang, languages } = useLang();
  const base = 'font-mono transition-all rounded';
  if (variant === 'welcome') {
    return (
      <div className="flex flex-wrap gap-2 justify-center" data-testid="language-selector">
        {languages.map((l) => (
          <button
            key={l.code}
            data-testid={`language-selector-${l.code}`}
            onClick={() => setLang(l.code)}
            className={`${base} px-3.5 py-2 text-sm border ${
              lang === l.code
                ? 'bg-[#D4AF37] text-[#070C1E] border-[#E5C158] font-semibold'
                : 'bg-transparent text-slate-300 border-[#D4AF37]/30 hover:text-[#E5C158]'
            }`}
          >
            {l.label}
          </button>
        ))}
      </div>
    );
  }
  return (
    <div className="flex gap-1 bg-[#111A38] border border-[#D4AF37]/30 p-1 rounded-lg" data-testid="language-selector">
      {languages.map((l) => (
        <button
          key={l.code}
          data-testid={`language-selector-${l.code}`}
          onClick={() => setLang(l.code)}
          className={`${base} px-2 py-1 text-xs ${
            lang === l.code ? 'bg-[#D4AF37] text-[#070C1E] font-semibold' : 'text-slate-300 hover:text-[#E5C158]'
          }`}
        >
          {l.label}
        </button>
      ))}
    </div>
  );
}
